import { FILTER_API_BASE_URL } from '../config';

export const FilterSuggestionsAPIRoutes = {
  searchSuggestions: () => `${FILTER_API_BASE_URL}/suggestions`,
};
